import { queryOptions, useQuery } from '@tanstack/react-query';
import { getMe } from '@mkcore/platform/schema';
import { ApiError, call } from './api';

export const meQuery = queryOptions({
  queryKey: ['admin', 'me'],
  queryFn: async () => {
    try {
      return await call(getMe, {});
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) return null;
      throw e;
    }
  },
  staleTime: 60_000,
});

export type Me = NonNullable<Awaited<ReturnType<typeof meQuery.queryFn & object>>>;

/** The signed-in user; routes under the app shell ensure it exists before rendering. */
export function useMe(): Me {
  const { data } = useQuery(meQuery);
  if (!data) throw new Error('useMe outside a signed-in route');
  return data;
}

export function useCan(permission: string): boolean {
  const { data } = useQuery(meQuery);
  return !!data && (permission === 'authenticated' || data.permissions.includes(permission));
}

export async function signOut() {
  await fetch('/api/auth/sign-out', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: '{}' });
}
